// src/pages/sign-in-sign-up/sign-in-sign-up.component.jsx
import React, { useState } from 'react';
import SignIn from '../../components/sign-in/sign-in.component';
import SignUp from '../../components/sign-up/sign-up.component';
import './sign-in-sign-up.styles.scss';

const SignInAndSignUp = () => {
  const [activeTab, setActiveTab] = useState('signin');

  return (
    <div className='sign-in-sign-up-page'>
      <div className='auth-container'>
        <div className='auth-tabs'>
          <button 
            className={`tab ${activeTab === 'signin' ? 'active' : ''}`}
            onClick={() => setActiveTab('signin')}
          >
            Sign In
          </button>
          <button 
            className={`tab ${activeTab === 'signup' ? 'active' : ''}`}
            onClick={() => setActiveTab('signup')}
          >
            Sign Up
          </button>
        </div>
        <div className='auth-content'>
          {activeTab === 'signin' ? <SignIn /> : <SignUp />}
        </div>
      </div>
    </div>
  );
};

export default SignInAndSignUp;